  <div style="min-height: 350px;">
    <div class="pb-3">
      <p-button [link]="true" (click)="export()">
        <i class="pi pi-upload pr-2"></i>
        <span class="table-action-link font-bold">{{'buttons.export' | translate}}</span>
      </p-button>
    </div>

    <p-table
      [value]="actions"
      [scrollable]="true"
      scrollHeight="400px"
      [tableStyle]="{ 'min-width': '50rem' }">
      <ng-template pTemplate="header">
        <tr>
          @for (header of actionHeader; track $index) {
            <th [pSortableColumn]="header.id" [id]="header.id" sty>
              <span style="font-size: 0.9rem;">{{ header.value | translate }}</span>
              <p-sortIcon [field]="header.id" />
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-action>
        <tr>
          @for (header of actionHeader; track $index) {
            <td>
              @if(header.type == 'tag') {
                @if(action[header.id]) {
                  <p-tag severity="success">Activé</p-tag>
                }@else {
                  <p-tag severity="danger">Désactivé</p-tag>
                }
              }@else if(header.type == 'date') {
                {{ action[header.id] | date:"dd/MM/yyyy HH:mm"}}
              }@else {
                {{ action[header.id] }}
              }

            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
